export default __webpack_public_path__ + "static/media/HAIR_PER_HAIR_FOLLICLE.0c72faeb.png";